import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';
import { LiegtypselectObject } from '../../../bs/types';

class LiegtypselectComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['../../../../node_modules/@geogirafe/lib-geoportal/styles/common.css', '../style.css', './style.css'];

  list: LiegtypselectObject[] = [];

  private handleItemClickBound: (evt: Event) => void;
  private handleCloseClickBound: (evt: Event) => void;

  constructor() {
    super('liegtypselect-component');

    this.handleItemClickBound = this.handleItemClick.bind(this);
    this.handleCloseClickBound = this.handleCloseClick.bind(this);
  }

  override connectedCallback() {
    super.render();
    this.registerEventHandlers();
  }

  setList(newList: LiegtypselectObject[]) {
    this.list = newList;
    super.render();
    this.registerEventHandlers();
  }

  private registerEventHandlers() {
    const container = this.shadowRoot?.querySelector('#lieg-items');
    if (container) {
      container.querySelectorAll('.liegtypselect-item').forEach((btn) => {
        btn.removeEventListener('click', this.handleItemClickBound);
        btn.addEventListener('click', this.handleItemClickBound);
      });
    }
    const closeBtn = this.shadowRoot?.querySelector('#close-btn');
    if (closeBtn) {
      closeBtn.removeEventListener('click', this.handleCloseClickBound);
      closeBtn.addEventListener('click', this.handleCloseClickBound);
    }
    super.render();
  }

  private handleItemClick(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    const target = ev.currentTarget as HTMLElement;
    const egrid = target.getAttribute('data-egrid');
    if (egrid) {
      this.dispatchEvent(
        new CustomEvent('select', {
          detail: { egrid } as LiegtypselectObject,
          bubbles: true,
          composed: true
        })
      );
    }
  }

  private handleCloseClick(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    this.dispatchEvent(
      new CustomEvent('close', {
        bubbles: true,
        composed: true
      })
    );
  }
}

export default LiegtypselectComponent;
